(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldOptionDeleteController',SegmentFieldOptionDeleteController);

    SegmentFieldOptionDeleteController.$inject = ['$uibModalInstance', 'entity', 'SegmentFieldOption'];

    function SegmentFieldOptionDeleteController($uibModalInstance, entity, SegmentFieldOption) {
        var vm = this;

        vm.segmentFieldOption = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SegmentFieldOption.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
